import type {
  SuggestionItem,
  SuggestionSection,
} from 'src/components/agentic-ui/editor';
import type {TypeaheadApiItem} from 'src/types/askai-typeahead';


const NAVIGATE_ICON = 'arrow-right';
const ASK_SENSE_IQ_ICON = 'sparkles';

// Maps the flat typeahead API response into ordered, grouped suggestion
// sections: Navigate (route links) first, then Ask Sense IQ (query starters).
export function toSuggestionSections(
  items: TypeaheadApiItem[],
  t: (key: string, fallback: string) => string,
): SuggestionSection[] {
  const pages = items.filter((i) => i.group === 'pages');
  const starters = items.filter((i) => i.group === 'conversation_starters');

  const sections: SuggestionSection[] = [];
  if (pages.length) {
    sections.push({
      key: 'navigate',
      title: t('Navigate', 'Navigate'),
      items: pages.map(
        (p): SuggestionItem => ({
          key: p.id,
          label: p.name,
          iconLeft: NAVIGATE_ICON,
          meta: p.group,
        }),
      ),
    });
  }
  if (starters.length) {
    sections.push({
      key: 'ask_sense_iq',
      title: t('Ask_Sense_IQ', 'Ask Sense IQ'),
      items: starters.map(
        (s): SuggestionItem => ({
          key: s.id,
          label: s.name,
          iconLeft: ASK_SENSE_IQ_ICON,
          meta: s.group,
        }),
      ),
    });
  }
  return sections;
}
